var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_RadarLayer = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_CanvasLayer(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "RadarLayer",
        legend_type: 'radar',
        options: {
            resolution: 200, // Mercator meters per pixel
            useRetina: true,
            draw_init: false,
            drawing_incr: 10
        },
        on_render: function (src) {
            if (this.visible && (this.get_ol_object().getOpacity() > 0.0)) {
                this.parent(src);
            }
        },
        get_layer_prod_id: function () {
            var source = this.get_source_obj();
            var variable = source.get_variables()[0];
            return variable.site + "_" + variable.parm;
        }
    });
};
OCS.Viewer.Classes.RadarLayer = OCS.Viewer.Functions.define_RadarLayer();
